import React, { useEffect, useState } from 'react';
import T from 'prop-types';
import throttle from 'lodash.throttle';

import overflow from './overflow';
import Dropdown from './dropdown';

function ListItems(props) {
  const { collection, current, handleClick, index } = props;
  const items = collection.map((row) => {
    const { lang, name } = row;
    const selected = lang === current?.lang ? 'selected' : '';
    const classNames = `transition-colors text-white focus:outline-none ml-1 block py-8 px-12 no-underline text-label2 ${
      selected ? 'bg-dark-grey' : ''
    } hover:bg-gui-active rounded`;
    return (
      <li key={lang} className={`mb-12 inline-block rounded-sm ${selected}`}>
        <button data-id={lang} onClick={handleClick} className={classNames}>
          {name}
        </button>
      </li>
    );
  });

  const opacity = index === 0 ? 'opacity-0' : 'opacity-100';
  const classNames = `${opacity} p-0 m-0 list-none inline-block text-right`;

  return <ul className={classNames}>{items}</ul>;
}

ListItems.propTypes = {
  collection: T.array,
  current: T.object,
  handleClick: T.func,
  index: T.number,
};

function OverflowIndicator(props) {
  const { collection, current, index, handleClick } = props;

  if (index < 0) return null;

  return (
    <div className="ui-code-explorer-overflow">
      <Dropdown collection={collection} current={current} update={handleClick} />
    </div>
  );
}

OverflowIndicator.propTypes = {
  index: T.number,
  current: T.object,
  handleClick: T.func,
  updateCurrent: T.func,
  collection: T.array,
};

export default function LanguageNavigation(props) {
  const { id, handleClick, current } = props;
  const [overflowItems, setOverflowItems] = useState();

  const updateNavlist = (e) => {
    const overflowCollection = overflow(e, id);
    setOverflowItems(overflowCollection);
  };

  useEffect(() => {
    // respond to resize event and update visible list
    const handleChanges = (el) => {
      const { contentRect } = el[0];
      if (!contentRect?.width) return;
      Array.from(el).forEach(updateNavlist);
    };
    const selector = `[data-id=${id}] .ui-code-explorer-language-navigation`;
    const container = document.querySelector(selector);
    updateNavlist({ target: container });

    if (typeof ResizeObserver !== 'undefined') {
      const resizer = new ResizeObserver(handleChanges);
      resizer.observe(container);
      return () => resizer.disconnect();
    }

    const resizerHandler = throttle(() => {
      updateNavlist({ target: container });
    }, 100);
    window.addEventListener('resize', resizerHandler);
    return () => window.removeEventListener('resize', resizerHandler);
  }, [id, current]);

  const { index = null, items = null } = overflowItems || {};

  return (
    <div className="relative flex w-full justify-end" data-id={id}>
      <div className="ui-code-explorer-language-navigation">
        <ListItems {...props} index={index} />
      </div>
      <OverflowIndicator collection={items} index={index} current={current} handleClick={handleClick} />
    </div>
  );
}

LanguageNavigation.propTypes = {
  id: T.string,
  collection: T.array,
  handleClick: T.func,
  current: T.object,
};
